const Group = {
    name: '',
}

export default Group;